export var BREAKPOINT_HORIZONTAL_SIDEPANEL = 1024;